import { Typography } from '@optimus-web/core';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { ProductOrderLabel } from '../../../../../components';
import { ProductOrder } from '../../../transformProductOrders/types';
import { GroupCost } from '../../ItemsTab/GroupCost';
import { OffsetStack } from './styles';

interface ProductOrderItemRow {
    order: ProductOrder;
    isMultiTaxEnvironment: boolean;
    timeUnitKey: Mews.TextKey;
    depth?: number;
    isSingleOrderGroup?: boolean;
}

export const ProductOrderItemRow: React.FC<ProductOrderItemRow> = ({
    isMultiTaxEnvironment,
    order,
    timeUnitKey,
    depth = 0,
    isSingleOrderGroup = false,
}) => {
    const { consumptionUtc, multipliers, unitAmount, data } = order;

    return (
        <OffsetStack offset={depth} distribution="space-between">
            <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
                {isSingleOrderGroup ? (
                    <ProductOrderLabel productId={data.value.productId} ageCategoryId={data.value.ageCategoryId} />
                ) : (
                    <>{consumptionUtc ? <LocalizedDateFromUtc utcString={consumptionUtc} /> : null}</>
                )}
            </Typography>
            <GroupCost
                multipliers={multipliers}
                amount={unitAmount}
                timeUnitKey={timeUnitKey}
                net={isMultiTaxEnvironment}
            />
        </OffsetStack>
    );
};
